'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputEnhancer = require('../Input/inputEnhancer');

var _inputEnhancer2 = _interopRequireDefault(_inputEnhancer);

var _Textarea = require('./Textarea');

var _Textarea2 = _interopRequireDefault(_Textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Textarea = (0, _inputEnhancer2.default)(_Textarea2.default);
Textarea.displayName = 'Textarea';

exports.default = Textarea;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Textarea/index.js
// module id = 1772
// module chunks = 0